<template>
    <div class="app__page-wrapper | u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-wizard-padding-bottom u-full-height">
            <div class="layout__item u-4/5-desk">
                <wizard-steps :step="1" />

                <search-partial />

                <domain-results :ownedDomains="domainServices" />
            </div>
        </div>
        <wizard-footer>
            <div class="button-nav-submit">
                <customer-router-link :to="{ name: 'orderFullHosting' }">
                    <button type="button" class="btn btn--ghost btn--submit btn--nav" dusk="step1-submit-button">
                        {{ trans('order.navigation.hosting') }}
                    </button>
                </customer-router-link>
            </div>
        </wizard-footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import WizardSteps from '@/components/WizardSteps.vue';
import WizardFooter from '@/components/WizardFooter.vue';
import { SearchPartial, DomainResults, productsMixin, supportMixin, orderPageMixin } from 'relapp-register';

export default {
    components: {
        WizardSteps,
        WizardFooter,
        DomainResults,
        SearchPartial
    },
    mixins: [productsMixin, supportMixin, orderPageMixin],
    props: {},
    metaInfo: {
        title: trans('page.order.domain')
    },
    computed: {
        ...mapGetters({
            domainServices: 'services/domainServices'
        })
    }
};
</script>
